/*
 * Calculadora de frete por CEP.
 *
 * Consulta /cart/shipping_rates.json, que devolve as tarifas configuradas para o
 * carrinho atual. As opcoes vem das regras de envio da loja ou do app de frete;
 * o tema so exibe o que a Shopify devolver.
 */
if (!customElements.get('calculo-frete')) {
  customElements.define(
    'calculo-frete',
    class CalculoFrete extends HTMLElement {
      connectedCallback() {
        this.entrada = this.querySelector('[data-cep]');
        this.botao = this.querySelector('[data-calcular]');
        this.mensagem = this.querySelector('[data-mensagem]');
        this.resultados = this.querySelector('[data-resultados]');
        this.textos = JSON.parse(this.querySelector('[data-textos]').textContent);
        this.pais = this.dataset.pais === 'BR' ? 'Brazil' : this.dataset.pais;

        this.entrada.addEventListener('input', () => this.mascarar());
        this.entrada.addEventListener('keydown', (evento) => {
          if (evento.key === 'Enter') {
            evento.preventDefault();
            this.calcular();
          }
        });
        this.botao.addEventListener('click', () => this.calcular());
      }

      mascarar() {
        const digitos = this.entrada.value.replace(/\D/g, '').slice(0, 8);
        this.entrada.value = digitos.length > 5 ? `${digitos.slice(0, 5)}-${digitos.slice(5)}` : digitos;
      }

      exibirMensagem(texto) {
        this.mensagem.textContent = texto;
        this.mensagem.hidden = false;
        this.resultados.hidden = true;
        this.resultados.innerHTML = '';
      }

      async calcular() {
        const cep = this.entrada.value.replace(/\D/g, '');

        if (cep.length !== 8) {
          this.exibirMensagem(this.textos.invalido);
          this.entrada.focus();
          return;
        }

        this.botao.setAttribute('disabled', 'disabled');
        this.exibirMensagem(this.textos.calculando);

        const parametros = new URLSearchParams({
          'shipping_address[zip]': cep,
          'shipping_address[country]': this.pais,
        });

        try {
          const resposta = await fetch(`${window.Shopify.routes.root}cart/shipping_rates.json?${parametros}`);

          if (!resposta.ok) {
            this.exibirMensagem(resposta.status === 422 ? this.textos.invalido : this.textos.erro);
            return;
          }

          const dados = await resposta.json();
          this.renderizar(dados.shipping_rates || []);
        } catch (erro) {
          console.error(erro);
          this.exibirMensagem(this.textos.erro);
        } finally {
          this.botao.removeAttribute('disabled');
        }
      }

      renderizar(tarifas) {
        if (tarifas.length === 0) {
          this.exibirMensagem(this.textos.sem_opcoes);
          return;
        }

        this.mensagem.hidden = true;
        this.resultados.hidden = false;
        this.resultados.innerHTML = tarifas.map((tarifa) => this.linha(tarifa)).join('');
      }

      linha(tarifa) {
        const centavos = Math.round(parseFloat(tarifa.price) * 100);
        const valor = centavos === 0 ? this.textos.gratis : this.formatarMoeda(centavos);
        const prazo = this.formatarPrazo(tarifa.delivery_range);

        return `
          <li class="calculo-frete__opcao">
            <span class="calculo-frete__opcao-nome">
              ${this.escapar(tarifa.name)}
              ${prazo ? `<span class="calculo-frete__opcao-prazo">${prazo}</span>` : ''}
            </span>
            <span class="calculo-frete__opcao-valor">${valor}</span>
          </li>
        `;
      }

      formatarMoeda(centavos) {
        return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
          style: 'currency',
          currency: window.Shopify.currency.active,
        }).format(centavos / 100);
      }

      // delivery_range vem como ["AAAA-MM-DD", "AAAA-MM-DD"] ou null.
      formatarPrazo(intervalo) {
        if (!Array.isArray(intervalo) || intervalo.length === 0) return '';

        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);

        const dias = intervalo.map((data) => {
          const [ano, mes, dia] = data.split('-').map(Number);
          return Math.max(0, Math.round((new Date(ano, mes - 1, dia) - hoje) / 86400000));
        });

        const minimo = Math.min(...dias);
        const maximo = Math.max(...dias);

        if (maximo === 0) return '';
        return minimo === maximo ? `${maximo} dias` : `${minimo} a ${maximo} dias`;
      }

      escapar(texto) {
        const elemento = document.createElement('span');
        elemento.textContent = texto;
        return elemento.innerHTML;
      }
    }
  );
}
